export const flexSBC = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};
